var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMensajes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1719 4.125H4.67189C4.17461 4.125 3.6977 4.32254 3.34607 4.67417C2.99444 5.02581 2.79689 5.50272 2.79689 6V21C2.79539 21.3571 2.89681 21.707 3.08901 22.0079C3.28121 22.3089 3.55605 22.5481 3.88064 22.6969C4.12981 22.8135 4.40146 22.8743 4.67658 22.875C5.11685 22.8739 5.54255 22.7171 5.87845 22.4325L5.89627 22.4175L8.79689 19.875H21.1719C21.6692 19.875 22.1461 19.6775 22.4977 19.3258C22.8493 18.9742 23.0469 18.4973 23.0469 18V6C23.0469 5.50272 22.8493 5.02581 22.4977 4.67417C22.1461 4.32254 21.6692 4.125 21.1719 4.125ZM20.7969 17.625H8.65627C8.21486 17.625 7.7876 17.7807 7.4497 18.0647L7.43189 18.0797L5.04689 20.1694V6.375H20.7969V17.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMensajes);
export default __webpack_public_path__ + "static/media/icon_mensajes.b2263c24d4f6258e885fa137cf6beed8.svg";
export { ForwardRef as ReactComponent };